import Component from "@glimmer/component";
import { action } from "@ember/object";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { bool, func, oneOf } from "prop-types";
import { tracked } from "@glimmer/tracking";
import { stringable } from "glesys-controlpanel/utils/prop-types";
import { service } from "@ember/service";

@forbidExtraArgs
export default class AtomDelete extends Component {
  @service intl;

  @arg(func.isRequired) onDelete;
  @arg(bool) disabled = false;
  @arg(bool) requiresConfirmation = true;
  @arg(oneOf(["icon", "button"])) type = "icon";
  @arg(stringable) ariaLabel = this.intl.t("atom-delete.delete");

  optionValues = {};
  @tracked showConfirm = false;

  get buttonClass() {
    let base = "size-6 inline-flex items-center";

    return this.disabled ? `${base} text-gray-600 cursor-not-allowed` : `${base} text-red-200 hover:text-red-800`;
  }

  @action
  changeOption(option, event) {
    this.optionValues[option] = event.target.checked;
  }

  @action
  toggleConfirm() {
    this.showConfirm = !this.showConfirm;
  }

  @action
  hideConfirm() {
    this.showConfirm = false;
  }

  @action
  confirm() {
    let options = this.optionValues;
    this.onDelete(options);
    this.showConfirm = false;
  }

  @action
  delete() {
    let options = this.optionValues;
    this.onDelete(options);
  }
}
